module.exports = __webpack_public_path__ + "static/img/huanglian.6b8043c.png";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/huanglian.png
// module id = leZ8
// module chunks = 1